import React, { useCallback, useState, useEffect } from "react";
import { BusinessIvaProRataForm } from "../../../../../../components/form/business/ivaprorata";
import { useNavigate, useParams } from "react-router-dom";
import { useGetBusiness } from "../../../../../../hooks/api/business/useGetBusiness";
import { useGetAdditionalBusinessDetails } from "../../../../../../hooks/api/business/useGetAdditionalBusinessDetails";
import { Stack } from "@vapor/react-material";
import { usePostAdditionalBusinessDetails } from "../../../../../../hooks/api/business/usePostAdditionalBusinessDetails";

export const BusinessIvaProRata = ({ setBusiness }) => {
    const { workspaceId, businessId } = useParams();
    const navigate = useNavigate();
    const [bodyRequest, setBodyRequest] = useState({
        ivaProRataHandled: false
    });
    const [items, setItems] = useState<any>([
        {
            id: new Date().getFullYear(),
            proRataYear: new Date().getFullYear(),
            proRataManagementType: "NON_DEDUCTIBLE_VAT_ON_COSTS",
            proRataNonDeducibilityRate: 0
        }
    ]);
    const [itemToSave, setItemToSave] = useState<any>({});
    const [isEditing, setIsEditing] = useState<any>(false);
    const [isEditingItem, setIsEditingItem] = useState<any>(null);

    const { data: business, loading: loadingGet, fetch: getBusiness } = useGetBusiness(workspaceId, businessId);

    const { data: ivaProRatas, loading: loadingIvaProRatas } = useGetAdditionalBusinessDetails(
        workspaceId,
        businessId,
        "iva-pro-rata"
    );

    const { loading: loadingPost, fetch: postIvaProRata } = usePostAdditionalBusinessDetails(
        workspaceId,
        businessId,
        "iva-pro-rata"
    );

    const dateYear = new Date().getFullYear();

    const handleChange = useCallback(
        (value, field) => {
            setBodyRequest({ ...bodyRequest, [field]: value });
        },
        [bodyRequest]
    );

    const onForward = useCallback(() => {
        if (bodyRequest?.ivaProRataHandled) {
            const { id, idIvaProRata, proRataNonDeducibilityRate, ...payload } = items[0];

            postIvaProRata({
                data: {
                    ...payload,
                    proRataNonDeducibilityRate: parseInt(proRataNonDeducibilityRate)
                }
            }).then(res => {
                navigate(`/details/${workspaceId}/business`);
            });
        } else {
            navigate(`/details/${workspaceId}/business`);
        }
    }, [bodyRequest, workspaceId, navigate, postIvaProRata, items]);

    const onBack = useCallback(() => {
        navigate(`/details/${workspaceId}/business/wizard/${businessId}/vatconfiguration`);
    }, [navigate, workspaceId, businessId]);

    useEffect(() => {
        if (businessId && !business && !loadingGet) {
            setIsEditing(false);
            getBusiness?.().then(res => {
                setBusiness(res?.data);
                setIsEditing(true);
            });
        }
    }, [businessId, getBusiness, business, loadingGet, setBusiness]);

    useEffect(() => {
        const defaultItem = {
            id: dateYear,
            idIvaProRata: null,
            proRataManagementType: "NON_DEDUCTIBLE_VAT_ON_COSTS",
            proRataYear: dateYear,
            proRataNonDeducibilityRate: "100"
        };

        if (ivaProRatas?.length > 0) {
            const ivaProRataOfCurrentYear = ivaProRatas?.find(item => item?.proRataYear === dateYear);

            if (ivaProRataOfCurrentYear) {
                setItems(
                    ivaProRataOfCurrentYear?.map(item => {
                        return {
                            ...item,
                            id: item?.proRataYear,
                            idIvaProRata: item?.id,
                            proRataNonDeducibilityRate: `${item?.proRataNonDeducibilityRate}%`
                        };
                    })
                );
                setIsEditing(null);
            } else {
                setItems([defaultItem]);
                setItemToSave(defaultItem);
            }
        } else {
            setItems([defaultItem]);
            setItemToSave(defaultItem);
        }
    }, [ivaProRatas, dateYear]);

    return (
        <Stack width={768}>
            <BusinessIvaProRataForm
                items={items}
                setItems={setItems}
                businessId={businessId}
                pastIvaProRata={[]}
                bodyRequest={bodyRequest}
                handleChange={handleChange}
                onForward={onForward}
                onBack={onBack}
                itemToSave={itemToSave}
                setItemToSave={setItemToSave}
                onDelete={() => {}}
                isEditingItem={isEditingItem}
                setIsEditingItem={setIsEditingItem}
                isEditing={isEditing}
                loading={loadingGet || loadingIvaProRatas || loadingPost}
                isNewBusiness={true}
            />
        </Stack>
    );
};
